AOS.init();

document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector(".wd-start-from-zero-to-up-wrapper");
  if (!wrapper) return;

  function animateNumber(el) {
    const original = el.textContent.trim();

    // --- Parse German number format ---
    // German: 1.300.000 (dots = thousands sep), 97,61 (comma = decimal sep)
    // Step 1: detect if there's a decimal comma
    const hasDecimalComma = /,\d+/.test(original);

    // Extract only the numeric portion (strip prefix/suffix like %)
    const prefix = original.match(/^[^0-9]*/)[0];
    const suffix = original.match(/[^0-9.,]*$/) ? original.match(/[^0-9.,]*$/)[0] : "";

    // Get the raw number string (between prefix and suffix)
    const numberStr = original.slice(prefix.length, suffix.length > 0 ? -suffix.length : undefined);

    // Convert German number string to a JS float:
    // Remove thousands dots, replace decimal comma with dot
    let normalizedStr = numberStr.replace(/\./g, "").replace(",", ".");
    const target = parseFloat(normalizedStr);
    if (isNaN(target)) return;

    // How many decimal places after the comma?
    const decimals = hasDecimalComma
      ? (numberStr.split(",")[1]?.length || 0)
      : 0;

    // How many digits in the integer part (for thousands formatting)?
    const integerPartStr = numberStr.split(",")[0].replace(/\./g, "");

    // Format a number back into German style: 1300000 -> "1.300.000"
    function formatGerman(num) {
      if (decimals > 0) {
        // Fixed decimals, then format integer part with dots
        const [intPart, decPart] = num.toFixed(decimals).split(".");
        return formatThousands(intPart) + "," + decPart;
      } else {
        return formatThousands(Math.floor(num).toString());
      }
    }

    function formatThousands(intStr) {
      // Only add thousand dots if the original had them
      const originalIntPart = numberStr.split(",")[0];
      const hadThousandDots = originalIntPart.includes(".");
      if (!hadThousandDots) return intStr;
      // Insert dots every 3 digits from the right
      return intStr.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }

    const duration = 2000; // slightly faster (was 3000)
    const startTime = performance.now();

    function update(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // Ease out cubic
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = eased * target;

      el.textContent = prefix + formatGerman(current) + suffix;

      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        el.textContent = original; // restore exact original value
      }
    }

    requestAnimationFrame(update);
  }

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          const numbers = wrapper.querySelectorAll(".wd-scroll-number");
          numbers.forEach(animateNumber);
          observer.unobserve(wrapper);
        }
      });
    },
    { threshold: 0.2 }
  );

  observer.observe(wrapper);
});

$(document).ready(function () {
  const $section = $('.newsletter-section.wd-newsletter-wrapper.overlay-on-scrolling-video');
  let isFixed = false;

  $(window).on('scroll', function () {
    const scrollTop = $(window).scrollTop();
    const windowHeight = $(window).height();
    const sectionOffset = $section.offset().top; // get fresh offset each time
    const sectionHeight = $section.outerHeight();
    const sectionBottom = sectionOffset + sectionHeight;

    // Section 100% visible
    if (sectionOffset >= scrollTop && sectionBottom <= scrollTop + windowHeight) {
      isFixed = true;
    }

    if (isFixed) {
      $section.addClass('wd-fixed');
    }

    // Remove only when scrolled back above section
    if (scrollTop < sectionOffset - windowHeight) {
      isFixed = false;
      $section.removeClass('wd-fixed');
    }
  });
});

$(document).ready(function () {
  function updateBodyClass() {
    var isChecked = $('.wd-sensia-variant-selector input.wd:checked').length > 0;
    $('body').toggleClass('wd-sensia-variant-active', isChecked);
  }

  $(document).on('change', '.wd-sensia-variant-selector input.wd', updateBodyClass);

  updateBodyClass();
});

document.addEventListener('DOMContentLoaded', function () {
  const btn = document.querySelector('.wd-video-overlay-wrapper-btn a');
  if (!btn) return;

  btn.addEventListener('click', function (e) {
    e.preventDefault();
    const target = document.querySelector(this.getAttribute('href'));
    if (!target) return;

    target.scrollIntoView({ behavior: 'smooth' });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('.wd-newsletter-wrapper.overlay-on-scrolling-video .newsletter-form');
  if (!form) return;

  form.addEventListener('click', function () {
    const target = document.querySelector('#wd-custom-sensia-newsletter-wrapper');
    if (!target) return;

    target.scrollIntoView({ behavior: 'smooth' });

    // Wait for scroll to finish then trigger click on input
    setTimeout(function () {
      const input = target.querySelector('.hs-input');
      if (!input) return;
      input.focus();
      input.click();
    }, 800);
  });
});



/**
 * WD — Stepper + tier card logic
 * Only activates when .wd-tier-cards exists (card mode).
 * In dropdown mode the original mrk JS runs unchanged.
 */
(function () {
  'use strict';

  var STEP = 25; // Default fallback

  function roundUpToStep(val) {
    var n = parseInt(val, 10) || STEP;
    return Math.ceil(Math.max(n, STEP) / STEP) * STEP;
  }

  function init() {
    var form = document.querySelector('.mrk-multi-step-form');
    if (!form) return;

    // Get steps from data-steps attribute, fallback to 25
    STEP = parseInt(form.getAttribute('data-steps'), 10) || 25;

    // Only run in card mode
    var tierCards = form.querySelectorAll('.wd-tier-card');
    if (!tierCards.length) return;

    var input     = form.querySelector('.wd-stepper-input');
    var btnMinus  = form.querySelector('.wd-stepper-minus');
    var btnPlus   = form.querySelector('.wd-stepper-plus');
    var submitBtn = form.querySelector('.enter_number_of_pack_button');

    if (!input) return;

    // ── sync tier highlight ──────────────────────────────────
    function syncTierHighlight(qty) {
      qty = parseInt(qty, 10) || 0;
      var bestCard = null;
      tierCards.forEach(function (card) {
        var cardQty = parseInt(card.getAttribute('quantity'), 10);
        card.classList.remove('wd-tier-card--active');
        if (cardQty <= qty) bestCard = card;
      });
      if (bestCard) bestCard.classList.add('wd-tier-card--active');
    }

    // ── fire existing submit handler ─────────────────────────
    function triggerSubmit() {
      if (submitBtn) submitBtn.click();
    }

    // ── set quantity (user interaction) ─────────────────────
    // Highlights the matching tier card + fires submit
    function setQty(val) {
      input.value = val;
      syncTierHighlight(val);
      triggerSubmit();
    }

    // ── set quantity on page load ────────────────────────────
    // Only writes the input value, no card highlight, no submit
    function initQty(val) {
      input.value = val;
    }

    // ── tier card click ──────────────────────────────────────
    tierCards.forEach(function (card) {
      card.addEventListener('click', function () {
        setQty(parseInt(card.getAttribute('quantity'), 10));
      });
    });

    // ── stepper buttons ──────────────────────────────────────
    if (btnMinus) {
      btnMinus.addEventListener('click', function () {
        var current = parseInt(input.value, 10) || 0;
        setQty(Math.max(STEP, current - STEP));
      });
    }

    if (btnPlus) {
      btnPlus.addEventListener('click', function () {
        var current = parseInt(input.value, 10) || 0;
        setQty(current + STEP);
      });
    }

    // ── manual input ─────────────────────────────────────────
    input.addEventListener('blur', function () {
      setQty(roundUpToStep(input.value));
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        setQty(roundUpToStep(input.value));
      }
    });

    // ── initialise — no highlight, no submit ─────────────────
    initQty(input.value);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


